import { Nullable } from 'common-types';
import { ScanHistory } from '../scan-history-types';
import ScanHistoryStore from './scan-history-store';

export const setScanHistoryData = (data: ScanHistory[]) => {
  ScanHistoryStore.scanInfo = data;
};

export const setSelectedScanId = (scanId: Nullable<string>) => {
  ScanHistoryStore.selectedScanId = scanId;
};
